import { render } from "./partiesCard.vue?vue&type=template&id=7258cc07"
import script from "./partiesCard.vue?vue&type=script&lang=js"
export * from "./partiesCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__